import React, { useState } from "react";
import { Button, Tag, Modal, Typography } from "antd";
import { GiftOutlined } from "@ant-design/icons";

const { Text } = Typography;

const RELEASE_DATE = "2026-05-28";
const RELEASE_LABEL = "May 28, 2026";

function getRelativeDate() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const release = new Date(RELEASE_DATE);
  release.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today - release) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays <= 7) return `${diffDays} days ago`;
  return RELEASE_LABEL;
}

const WhatsNew = ({ setShowPlanModal, inline }) => {
  const [open, setOpen] = useState(false);

  // Only show for 7 days after release
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const release = new Date(RELEASE_DATE);
  release.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today - release) / (1000 * 60 * 60 * 24));
  if (diffDays < 0 || diffDays > 7) return null;

  const button = (
    <Button
      type="text"
      icon={<GiftOutlined />}
      onClick={() => setOpen(true)}
      style={{ color: "#7c3aed", fontWeight: 500, fontSize: 13 }}
    >
      What's New - {getRelativeDate()}
    </Button>
  );

  return (
    <>
      
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
          {button}
        </div>
      

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        title={<span><GiftOutlined style={{ marginRight: 8, color: "#7c3aed" }} />What's New - {RELEASE_LABEL}</span>}
        width={580}
      >
        <div style={{ padding: "8px 0" }}>
          <div style={{ marginBottom: 20 }}>
            <Text strong style={{ fontSize: 15 }}>New Features</Text>
          </div>

          <div style={{ marginBottom: 16, padding: "12px 14px", background: "#fffbe6", borderRadius: 8, border: "1px solid #ffe58f" }}>
            <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>1. Native Mailchimp, Kit & Klaviyo integrations</div>
            <p style={{ margin: 0, fontSize: 12, color: "#555", lineHeight: 1.6 }}>
              Paste your API key once in Account Settings → Integrations, then toggle the integration on any flow. Leads sync automatically — no Make.com or Zapier in the middle.
            </p>
            <Tag color="gold" style={{ marginTop: 8, fontSize: 11 }}>Settings → Integrations</Tag>
          </div>

          <div style={{ marginBottom: 16, padding: "12px 14px", background: "#f0f5ff", borderRadius: 8, border: "1px solid #d6e4ff" }}>
            <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>2. Choose when to push to integrations</div>
            <p style={{ margin: 0, fontSize: 12, color: "#555", lineHeight: 1.6 }}>
              New "When to push" control in the flow editor's Integrations modal. Pick <b>On flow completion</b> for one clean push per lead, or <b>Each answer</b> for real-time updates as the conversation progresses.
            </p>
            <Tag color="blue" style={{ marginTop: 8, fontSize: 11 }}>Flow Editor → Integrations</Tag>
          </div>

          <div style={{ marginBottom: 16, padding: "12px 14px", background: "#f5f0ff", borderRadius: 8, border: "1px solid #e8daff" }}>
            <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>3. AI Reply now pushes to your integrations</div>
            <p style={{ margin: 0, fontSize: 12, color: "#555", lineHeight: 1.6 }}>
              When the AI Reply node captures a new email, name, or phone from a conversation, the lead is pushed to Mailchimp / Kit / Klaviyo immediately. AI flows auto-lock to per-answer mode (since AI conversations don't have a completion event).
            </p>
            <Tag color="purple" style={{ marginTop: 8, fontSize: 11 }}>Flow Editor → AI Reply Node</Tag>
          </div>

          <div style={{ marginBottom: 16, padding: "12px 14px", background: "#e6f7ff", borderRadius: 8, border: "1px solid #b7e4ff" }}>
            <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>4. DeepSeek added as an AI provider</div>
            <p style={{ margin: 0, fontSize: 12, color: "#555", lineHeight: 1.6 }}>
              Connect your DeepSeek API key in Account Settings → AI Configuration. Pick <b>V4 Flash</b> (fast, dual-mode) or <b>V4 Pro</b> (heavier reasoning) in the AI Reply node. Cheap, fast, and OpenAI-compatible.
            </p>
            <Tag color="cyan" style={{ marginTop: 8, fontSize: 11 }}>Settings → AI Configuration</Tag>
          </div>

          <div style={{ marginTop: 24, marginBottom: 12 }}>
            <Text strong style={{ fontSize: 15 }}>Bug Fixes & Improvements</Text>
          </div>

          <div style={{ padding: "10px 14px", background: "#f9f9f9", borderRadius: 8 }}>
            <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12, color: "#555", lineHeight: 2 }}>
              <li>Mailchimp / Kit / Klaviyo now correctly bundle name and phone when email arrives last in the flow</li>
              <li>Per-flow integration toggles in the flow editor now actually gate dispatches (previously they were cosmetic)</li>
              <li>"Not connected" badges appear in the flow editor's Integrations modal when API keys are missing</li>
              <li>Account Settings → Integrations cleaned up — only natively supported platforms are shown</li>
            </ul>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WhatsNew;
